/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
// import { logEvent } from 'firebase/analytics';
import { useRouter } from 'next/router';
import { usePathname, useSearchParams } from 'next/navigation';
import { Modal } from '@madeeasy/universal-login';
import HorizontalScroll from './HorizontalScroll';
// import bookMarkSVG from '../home/icons/bookmark.svg';
import quizBGSVG from '../home/icons/mcqthumb.png';
import calendarSVG from '../home/icons/calendar.svg';
import notePadSVG from '../home/icons/notepad.svg';
import marksSVG from '../home/icons/marks.svg';
import time from '../home/icons/Time.svg';
import ViewAllButton from '../home/course-section/ViewAllButton';
import NoDataFound from './NoDataFound';
import { getCurrentOrgName } from '../../utils/helpers';
import { useUser } from '../../contexts/ssr-user-context';
import { useMiscellaneousData } from '../../contexts/ssr-miscellaneous-context';
import { HeaderContext } from '../../contexts/headerContext';

function QuizCardNew({
  sectionTitle, data, entityID, page, pageType = '1',
}) {
  const router = useRouter();
  const queryString = sectionTitle.toLowerCase().replace(/\s+/g, '-');
  const pageUrl = `/view-all/${entityID}`;
  // for add redireact to
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { user } = useUser();
  const { miscellaneousData } = useMiscellaneousData();
  const { showLogin, setShowLogin } = useContext(HeaderContext);
  const toggleModal = () => {
    // console.log('toggleModal');
    setShowLogin(false);
  };
  //-----
  const handleAttemptNow = (id, language = 'en') => {
    if (user?.id) {
      const host = window.location.origin;
      const url = `${host}/prep/daily-quiz/${id}?language=${language}`;
      window.open(url, '_self');
    } else {
      const targetPath = `/prep/daily-quiz/${id}?language=${language}`;
      const fullRedirectUrl = `https://${miscellaneousData?.hostname}${targetPath}`;
      const params = new URLSearchParams(searchParams.toString());
      params.set('redirectTo', fullRedirectUrl);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      //  `${pathname}?${params.toString()}`;
      window.history.replaceState(null, '', newUrl);
      setShowLogin(true);
    }
  };

  const handleViewResult = (id, lang) => {
    // logEvent(analytics, 'User_Clicked_On_Quiz', {
    //   QuizId: id,
    //   timestamp: new Date().getTime(),
    //   userId: user?.id,
    //   userName: user?.profile?.accountDetails?.name,
    //   email: user?.profile?.accountDetails?.email,
    //   phone: user?.profile?.accountDetails?.mobile,
    //   screenName: 'Home',
    // });
    // const host = window.location.origin;
    // const url = `${host}/prep/daily-quiz-result/${id}`;
    // window.open(url, '__blank');
    // router.push(`/daily-quiz-result/${id}`);
    if (user?.id) {
      router.push({
        pathname: `/daily-quiz-result/${id}`,
        query: { language: lang || 'en' },
      });
    } else {
      const targetPath = `/daily-quiz-result/${id}`;
      const fullRedirectUrl = `https://${miscellaneousData?.hostname}${targetPath}`;
      const params = new URLSearchParams(searchParams.toString());
      params.set('redirectTo', fullRedirectUrl);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      // `prep${pathname}?${params.toString()}`;
      window.history.replaceState(null, '', newUrl);
      setShowLogin(true);
    }
  };
  // eslint-disable-next-line consistent-return
  const streamTagHtml = (streamName) => {
    if (getCurrentOrgName() === 'madeeasyprime' || getCurrentOrgName() === 'madeeasy') {
      return (
        <div className="bg-[#F3F1FF] inline-block p-[5px] rounded-md">
          <p className="text-[#7263F8] text-[10px] lg:text-[12px]">
            {streamName}
          </p>
        </div>
      );
    }
  };

  // eslint-disable-next-line consistent-return
  const showManageButtonHTML = (item) => {
    if (item?.userQuizResponse !== null && Object.keys(item?.userQuizResponse).length) {
      if (item?.userQuizResponse.attemptStatus === 'STARTED') {
        return (
          <div className="flex flex-col items-end pt-[15px]">
            <button
              className={`bg-customBlue text-white text-sm font-medium py-1 lg:py-2 bottom-0 px-3 relative 
                ${streamTagHtml(item?.name) ? 'true' : 'lg:absolute'}
         rounded hover:bg-customBlue right-0`}
              onClick={() => handleAttemptNow(item?.id, item?.userQuizResponse.attemptData.attemptLang)}
            >
              Resume
            </button>
          </div>
        );
      }
      if (item?.userQuizResponse.attemptStatus === 'COMPLETED') {
        return (
          <div className="flex flex-col items-end pt-[15px]">
            <button
              className={`bg-customBlue text-white text-sm font-medium py-1 lg:py-2 bottom-0 px-3 relative 
              ${streamTagHtml(item?.name) ? 'true' : 'lg:absolute'}
       rounded hover:bg-customBlue right-0`}
      //  data.getQuizList.quizzes[1].userQuizResponse.attemptData.attemptLang
              onClick={() => handleViewResult(item?.id, item?.userQuizResponse.attemptData.attemptLang)}
            >
              View Result
            </button>
          </div>
        );
      }
    } else {
      return (
        <div className="flex flex-col items-end pt-[15px]">
          <button
            className={`bg-customBlue text-white text-sm font-medium py-1 lg:py-2 bottom-0 px-3 relative 
                ${streamTagHtml(data[0]?.quiz?.name) ? 'true' : 'lg:absolute'}
         rounded hover:bg-customBlue right-0`}
            onClick={() => handleAttemptNow(item?.id)}
          >
            Attempt Now
          </button>
        </div>
      );
    }
  };

  if (pageType === 'view-all') {
    return (
      <div>
        {/* flex flex-wrap gap-5 text-xs font-medium lg:font-semibold lg:text-base */}
        <div className={`${data?.length > 0 ? 'grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-2 gap-3 lg:gap-6' : ''}`}>

          { data?.length > 0 ? (
            data?.map((item, index) => (
              <div className={data.length - 1 === index ? 'test' : ''} key={item?.quiz?.id}>
                <div className="border border-blue-200 rounded-lg bg-white lg:w-full min-w-full p-3 pb-3 flex lg:justify-center ">
                  <div className="image-container mr-3 w-[28%] lg:w-[35%] relative">
                    <div>
                      <Image
                        width={500}
                        height={500}
                        src={quizBGSVG}
                        alt="Book Placeholder"
                        className="w-full lg:h-[155px] rounded-lg"
                      />
                    </div>
                    {/* <div className=" absolute top-[28px] lg:top-2 right-2">
                      <Image width={500} height={500}
                        src={bookMarkSVG}
                        alt="Bookmark Placeholder"
                      />
                    </div> */}
                  </div>
                  <div className="right-side w-[72%] lg:w-[65%] relative">
                    {streamTagHtml(item?.quiz?.name)}
                    <div className={`title text-lightBlack text-base lg:text-xl font-semibold line-clamp-1
                    ${streamTagHtml(data[0]?.name) ? 'true' : 'pt-1 lg:pt-2'} `}
                    >
                      <h4>
                        { item?.quiz?.name }
                      </h4>
                    </div>

                    <div className="pt-1 lg:pt-4 space-y-1 lg:space-y-2 ">
                      <div className="flex gap-4 lg:gap-13 items-center lg:justify-normal pb-2">
                        <div className="flex items-center space-x-1 lg:space-x-2 min-w-[100px] lg:min-w-[163px]">
                          <span>
                            <Image width={500} height={500} src={notePadSVG} alt="icon" className="w-[18px] lg:w-[22px]" />
                          </span>
                          <span className="text-lightBlack text-xs lg:text-sm font-normal">
                            { item?.quiz?.questionCount }
                            {' '}
                            Questions
                          </span>
                        </div>
                        <div className="flex items-center space-x-1 lg:space-x-2">
                          <span>
                            <Image width={500} height={500} src={time} alt="icon" className="w-[18px] lg:w-[22px]" />
                          </span>
                          <span className="text-lightBlack text-xs lg:text-sm font-normal">
                            { item?.quiz?.duration }
                          </span>
                        </div>
                      </div>
                      <div className="flex gap-4 lg:gap-13 items-center lg:justify-normal">

                        <div className="flex items-center space-x-1 lg:space-x-2 min-w-[100px] lg:min-w-[163px]">
                          <span>
                            <Image width={500} height={500} src={marksSVG} alt="icon" className="w-[18px] lg:w-[22px]" />
                          </span>
                          <span className="text-lightBlack text-xs lg:text-sm font-normal">
                            { item?.quiz?.maximumMarks }
                            {' '}
                            Marks
                          </span>
                        </div>
                        <div className="flex items-center space-x-1 lg:space-x-2">
                          <span>
                            <Image width={500} height={500} src={calendarSVG} alt="icon" className="w-[18px] lg:w-[22px]" />
                          </span>
                          <span className="text-lightBlack text-xs lg:text-sm font-normal">
                            {/* 19-09-2024 */}
                            {/* { item?.quiz?.createdAt } */}
                            {item?.quiz?.createdAt
                              && new Date(item?.quiz?.createdAt).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                              })}
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* Button */}
                    {/* {console.log('item?.testSeriesReport', item?.testSeriesReport)} */}
                    {showManageButtonHTML(item?.quiz)}

                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="flex justify-center items-center w-full min-h-80">
              <NoDataFound noMsg="No Daily MCQ'S match your selected date. Please try adjusting your date." />
            </div>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="">
      <div className="flex justify-between mb-[18px] lg:mb-[34px] items-center pr-5 lg:pr-0">
        <div className="xl:text-2xl text-lg font-semibold">{sectionTitle}</div>
        <ViewAllButton pageTitle={page} pageType="quiz" pageUrl={pageUrl} typeButton={2} hiddenLgBTn={false} queryString={`page=${queryString}`} />
      </div>
      <HorizontalScroll className="scrollbar-hide">
        <ul className="flex flex-shrink-0  gap-5 text-xs font-medium lg:font-semibold lg:text-base">
          { data?.length > 0 ? (
            data?.map((item) => (
              // className={data.length - 1 === index ? 'fkfk' : ''} key={item?.id}
              <li
                className="border border-blue-200 rounded-lg
                lg:min-w-[500px] bg-white min-w-[337px] p-3 pb-3 flex h-full lg:justify-center "
                key={item?.quiz?.id}
              >
                <div className="image-container mr-3 w-[28%] lg:w-[35%] relative">
                  <div>
                    <Image
                      src={quizBGSVG}
                      width={200}
                      height={200}
                      alt="Book Placeholder"
                      className="w-full lg:h-[155px] rounded-lg"
                    />
                  </div>
                  {/* <div className=" absolute top-[28px] lg:top-2 right-2">
                      <Image width={500} height={500}
                        src={bookMarkSVG}
                        alt="Bookmark Placeholder"
                      />
                    </div> */}
                </div>
                <div className="right-side w-[72%] lg:w-[65%] relative">
                  {streamTagHtml(item?.quiz?.name)}
                  <div className={`title text-lightBlack text-base lg:text-xl font-semibold line-clamp-1
                    ${streamTagHtml(item?.quiz?.name) ? 'true' : 'pt-1 lg:pt-2'} `}
                  >
                    <h4>
                      { item?.quiz?.name }
                    </h4>
                  </div>

                  <div className="pt-1 lg:pt-4 space-y-1 lg:space-y-2 ">
                    <div className="flex items-center lg:justify-normal">
                      <div className="flex items-center space-x-1 lg:space-x-2 min-w-[100px] lg:min-w-[167px]">
                        <span>
                          <Image width={22} height={22} src={notePadSVG} alt="icon" className="w-[18px] lg:w-[22px]" />
                        </span>
                        <span className="text-lightBlack text-xs lg:text-sm font-normal">
                          { item?.quiz?.questionCount }
                          {' '}
                          Questions
                        </span>
                      </div>
                      <div className="flex items-center space-x-1 lg:space-x-2">
                        <span>
                          <Image width={22} height={22} src={time} alt="icon" className="w-[18px] lg:w-[22px]" />
                        </span>
                        <span className="text-lightBlack text-xs lg:text-sm font-normal">
                          { item?.quiz?.duration }
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center lg:justify-normal pt-1 lg:pt-0">

                      <div className="flex items-center space-x-1 lg:space-x-2 min-w-[100px] lg:min-w-[167px]">
                        <span>
                          <Image width={22} height={22} src={marksSVG} alt="icon" className="w-[18px] lg:w-[22px]" />
                        </span>
                        <span className="text-lightBlack text-xs lg:text-sm font-normal">
                          { item?.quiz?.maximumMarks }
                          {' '}
                          Marks
                        </span>
                      </div>
                      <div className="flex items-center space-x-1 lg:space-x-2">
                        <span>
                          <Image width={22} height={22} src={calendarSVG} alt="icon" className="w-[18px] lg:w-[22px]" />
                        </span>
                        <span className="text-lightBlack text-xs lg:text-sm font-normal">
                          {/* { item?.quiz?.createdAt } */}
                          {item?.quiz?.createdAt
                             && new Date(item?.quiz?.createdAt).toLocaleDateString('en-GB', {
                               day: '2-digit',
                               month: 'short',
                               year: 'numeric',
                             })}
                        </span>
                      </div>
                    </div>
                  </div>
                  {showManageButtonHTML(item?.quiz)}

                </div>
              </li>
            ))
          ) : (
            // <p className="text-sm text-rose-500 w-full">No Data Found</p>
            <div className="flex justify-center items-center w-full min-h-64">
              <NoDataFound noMsg="No Data Found." />
            </div>
          )}
        </ul>
      </HorizontalScroll>
      {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}

    </div>
  );
}
QuizCardNew.propTypes = {
  sectionTitle: PropTypes.string,
  data: PropTypes.array.isRequired,
};

export default QuizCardNew;
